const AI_ASSISTANT_SESSION_KEY = 'tick2trade-ai-assistant-session-v1'

export type AiAssistantSession = {
    conversationId: string | null
    panelOpen: boolean
}

export function readAiAssistantSession(): AiAssistantSession {
    if (typeof window === 'undefined') {
        return { conversationId: null, panelOpen: false }
    }
    const raw = window.sessionStorage.getItem(AI_ASSISTANT_SESSION_KEY)
    if (!raw) {
        return { conversationId: null, panelOpen: false }
    }
    try {
        const parsed = JSON.parse(raw) as Partial<AiAssistantSession>
        return {
            conversationId:
                typeof parsed.conversationId === 'string' && parsed.conversationId.trim()
                    ? parsed.conversationId
                    : null,
            panelOpen: parsed.panelOpen === true,
        }
    } catch {
        return { conversationId: null, panelOpen: false }
    }
}

export function writeAiAssistantSession(session: AiAssistantSession): void {
    if (typeof window === 'undefined') return
    if (!session.conversationId && !session.panelOpen) {
        window.sessionStorage.removeItem(AI_ASSISTANT_SESSION_KEY)
        return
    }
    window.sessionStorage.setItem(AI_ASSISTANT_SESSION_KEY, JSON.stringify(session))
}

const AI_ASSISTANT_SCRATCH_NAV_KEY = 'tick2trade-ai-assistant-screener-scratch-nav'

/** Set before orchestrator navigation so StockScreener lands on scratch/default. */
export function markAiAssistantScreenerScratchNav(): void {
    if (typeof window === 'undefined') return
    window.sessionStorage.setItem(AI_ASSISTANT_SCRATCH_NAV_KEY, '1')
}

export function consumeAiAssistantScreenerScratchNav(): boolean {
    if (typeof window === 'undefined') return false
    if (window.sessionStorage.getItem(AI_ASSISTANT_SCRATCH_NAV_KEY) !== '1') return false
    window.sessionStorage.removeItem(AI_ASSISTANT_SCRATCH_NAV_KEY)
    return true
}
